import * as Actions from 'store/actions/app/cash_register_movements.actions'
import { addOrUpdateObjectInArray } from 'utils/add-or-update-object-in-array'
import { toggleIdInArray } from 'utils/toggle-id-in-array'

const initialState = {
  loading_cash_register_movements: false,
  cash_register_movements: [],

  saving_cash_register_movement: false,
  saved_cash_register_movement: false,

  voiding_cash_register_movement_ids: [],
  voided_cash_register_movement_ids: [],
}

export default function cashRegisterMovementsReducer(state = initialState, action) {
  switch (action.type) {
    case Actions.GET_CASH_REGISTER_MOVEMENTS: {
      return {
        ...state,
        loading_cash_register_movements: action.payload.loading,
        cash_register_movements: action.payload.data ?? state.cash_register_movements,
      }
    }
    case Actions.SAVE_CASH_REGISTER_MOVEMENT: {
      return {
        ...state,
        saving_cash_register_movement: action.payload.saving ?? state.saving_cash_register_movement,
        saved_cash_register_movement: action.payload.saved ?? false,
        cash_register_movements: action.payload.data
          ? addOrUpdateObjectInArray(state.cash_register_movements, action.payload.data, 'id_caja_chica', true)
          : state.cash_register_movements,
      }
    }
    case Actions.VOID_CASH_REGISTER_MOVEMENT: {
      return {
        ...state,
        voiding_cash_register_movement_ids: toggleIdInArray(state.voiding_cash_register_movement_ids, action.payload.voiding_id),
        voided_cash_register_movement_ids: toggleIdInArray(state.voided_cash_register_movement_ids, action.payload.voided_id),
        cash_register_movements: state.cash_register_movements.filter(({ id_caja_chica }) => id_caja_chica !== action.payload.voided_id)
      }
    }
    default: {
      return state
    }
  }
}
